import React, { Component } from 'react';
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

import HomeStatementLink from './components/statementLink';

const HomeImagesContainer = styled.p`

    text-align: center;

    img {
        width: 150px;
        margin-right: 50px;
    }
`;

const HomeMiddleLinksContainer = styled.div`
    width: 400px;
    margin: 20px auto;
    border: 1px solid rgb(0, 154, 195);

    a {
        cursor: pointer;
    }

`

class Home extends Component {

    constructor(props) {
        super(props);

        this.handleStatementLinkClick = this.handleStatementLinkClick.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleModalScroll = this.handleModalScroll.bind(this);

        this.state = {
            showModal: false,
        }

    }

    handleToggleModal() {
        this.setState({ 
            showModal: !this.state.showModal 
        });
    }

    handleModalScroll() {

        if (this.state.whichLinkId !== '') {
            const statementDiv = document.getElementsByClassName('modal-body')[0];
            const whichLinkTop = statementDiv.getElementsByClassName(this.state.whichLinkId)[0].offsetTop;
            if (whichLinkTop) {
                statementDiv.scrollTop = whichLinkTop - 10;
            }
        }
    }

    handleStatementLinkClick(e) {
        //if the title is missing, then set the modal title to the document id start - document id end
        this.setState({
            showModal:true,
            whichLinkId: e.currentTarget.id,
        }); 
    }    


    render() {
        return (
            <React.Fragment>
                ​​​​​​<h1>Welcome to the R.J. Reynolds Tobacco Company Online Litigation Document Archive</h1>
                <p>This website contains over 4 million documents that were produced in civil smoking and health litigation relating to the research, manufacturing, marketing, advertising and sales of cigarettes from the files of R.J. Reynolds Tobacco Company, and the entities formerly known as Brown & Williamson Tobacco Corporation (referred to here as "Brown & Williamson" or "B & W"), The American Tobacco Company (referred to here as "American" or "ATCO"), and Lorillard Tobacco Company (referred to here as “Lorillard”).</p>
                <p>Parents may wish to restrict their children's access to these materials. Software is available from these vendors to filter and block certain websites or content.</p>
                <HomeImagesContainer>
                    <a href="https://www.netnanny.com/" target="_blank"><img src={process.env.PUBLIC_URL + '/static/media/netnanny.png'} alt="NetNanny" /></a>
                    <a href="https://www.webwatcher.com/" target="_blank"><img src={process.env.PUBLIC_URL + '/static/media/webwatcher.png'} alt="Webwatcher" /></a>
                </HomeImagesContainer>

                <HomeMiddleLinksContainer>
                    <table width="358" height="212" align="center">
                        <tbody>
                            <tr>
                                <td width="358" height="212" align="left">
                                    <span>A Federal Court has ordered R.J. Reynolds Tobacco, Philip  Morris USA, Altria, and Lo​​rillard to mak​​e&nbsp;</span><a onClick={this.handleStatementLinkClick}><span>these statements</span></a>: 
                                    <ul>
                                        <li>
                                            <a onClick={this.handleStatementLinkClick}>Health effects ​of smok​ing</a>
                                        </li>
                                        <li>
                                            <a id="addiction" onClick={this.handleStatementLinkClick}>Addictiveness of smoking and nicotine</a>
                                        </li>
                                        <li>
                                            <a id="lowtar" onClick={this.handleStatementLinkClick}>Low tar and light cigarettes being as harmful as regular cigarettes</a>
                                        </li>
                                        <li>
                                            <a id="design" onClick={this.handleStatementLinkClick}>Designing cigarettes to enhance the delivery of nicotine</a>
                                        </li>
                                        <li>
                                            <a id="second" onClick={this.handleStatementLinkClick}>Health effects of secondhand smoke</a>
                                        </li>
                                        <li>
                                            <a id="spanish" onClick={this.handleStatementLinkClick}><i>Para información en español, clic aquí​ </i></a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </HomeMiddleLinksContainer>

                <p>This website may contain copyrighted material, the use of which, including reproduction, is governed by United States copyright laws (Title 17, United States Code). Federal law provides severe criminal and civil penalties for the unauthorized reproduction, distribution, or exhibition of copyrighted material. Criminal copyright infringement is investigated by the FBI and infringement may constitute a felony with a maximum penalty of up to 5 years in prison and/or heavy fines. Title 17 U.S.C. §§ 501, 506.</p>                
                <p>Each user of this website is responsible for ensuring the user's compliance with applicable copyright laws. Persons obtaining, or later using, a copy of copyrighted material in excess of "fair use" may become liable for copyright infringement. This law may permit the "fair use" of a copyrighted work, including the making of a photocopy, "for purposes such as criticism, comment, news reporting, teaching (including multiple copies for classroom use), scholarship or research." 17 U.S.C. § 107. By initiating a search on this website, the user agrees to defend, indemnify and hold harmless R.J. Reynolds Tobacco Company, its affiliates, and their directors, officers, employees and agents from and against all claims and expenses, including attorneys' fees, arising out of the use of this website by the user.</p>
                <p>R.J. Reynolds Tobacco Company reserves all rights under any applicable laws and rules concerning use, authenticity or admissibility in any litigation or proceedings of documents on this website.</p>
                <p>This website does not collect personal information. Therefore, you can surf this site (www.rjrtdocs.com) without telling us who you are or revealing any information about yourself. We do collect information for the purposes of improving site performance and usability including, for example, number of visits, average time spent on the site, and pages viewed. We do not sell, rent, or transmit information to other organizations or entities. We reserve the right to collect information for the purpose of preventing illegal and unauthorized access to database servers, website servers, and website features.</p>
                <p>Any use of Internet Browser Cookies on this website are for navigation and functionality purposes only; i.e., cookies are not used to collect information about users or their computer hardware and software.</p>
                <p>Our site may contain links to other sites that we think might be of interest to you. We are not responsible for the content or the privacy practices employed by these linked sites.</p>

                <Modal 
                    show={this.state.showModal} 
                    onHide={this.handleToggleModal}
                    dialogClassName="rjrHomeModal"
                    onEntered={this.handleModalScroll}
                >
                    <Modal.Header closeButton />
                    <Modal.Body>
                        <HomeStatementLink />
                    </Modal.Body>
                    </Modal>

            </React.Fragment>

            
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/staticContent/home/home.js